import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailVerified = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_2",
	"data-name": "Layer 2",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 332.83 337.04",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #def2ff;\n      }\n\n      .cls-2 {\n        fill: #007ca0;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 8.1px;\n      }\n\n      .cls-4 {\n        fill: #bbe5ff;\n      }\n\n      .cls-5 {\n        fill: #53c891;\n      }\n    " }) }),
		/* @__PURE__ */ _jsxs("g", {
			id: "Layer_1-2",
			"data-name": "Layer 1",
			children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M332.83,130.23v206.81s-3.24,0-3.24,0v-2.44s-130.43-98.16-130.43-98.16l-1.75-2.27,134.9-104.21s.07-.04.11-.06l.41.32Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-5",
					d: "M170.92,1.24l161.5,128.67s-.08.03-.11.06l-134.9,104.21-.62.48-27.94-21.03c-1.44-1.09-3.41-1.09-4.85,0l-25.45,19.14L1.76,127.06s-.01,0-.01-.01L163.86,1.2c2.09-1.62,5.01-1.59,7.07.04Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M196.79,234.65l.62-.48,1.75,2.27,130.43,98.16v2.44s-326.83,0-326.83,0v-2.07s133.91-100.78,133.91-100.78l1.59-1.21.28-.21,25.45-19.14c1.44-1.09,3.41-1.09,4.85,0l27.94,21.03Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-4",
					d: "M1.75,127.05s.01.01.01.01l136.79,105.7-.28.21-1.59,1.21L2.76,334.97v2.07s-2.76,0-2.76,0V127.93c0-.92,1.03-1.42,1.75-.89Z"
				})
			] }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M3.19,335.93c-.44.2-.97.07-1.27-.33-.35-.46-.26-1.12.21-1.47l133.91-100.78c.46-.35,1.12-.26,1.47.21.35.46.26,1.12-.21,1.47L3.4,335.81c-.06.05-.13.09-.2.12Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M330.02,335.56c-.34.15-.74.12-1.06-.12l-130.43-98.16c-.46-.35-.56-1.01-.21-1.47.35-.46,1.01-.56,1.47-.21l130.43,98.16c.46.35.56,1.01.21,1.47-.11.15-.25.26-.41.33Z"
			})] })] }), /* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M43.25,159.12V43.69c0-3.03,2.46-5.49,5.49-5.49h.1c2.03,0,4,1.03,4.93,2.84,1.33,2.59,4.39,4.41,7.96,4.41,3.57,0,6.64-1.82,7.97-4.41.93-1.81,2.89-2.84,4.93-2.84h4.26c2.03,0,4,1.03,4.93,2.84,1.33,2.59,4.4,4.41,7.97,4.41,3.56,0,6.63-1.82,7.96-4.41.93-1.81,2.89-2.84,4.93-2.84h4.09c2.03,0,4,1.04,4.92,2.84,1.33,2.59,4.38,4.41,7.96,4.41,3.56,0,6.63-1.82,7.96-4.41.93-1.81,2.89-2.84,4.93-2.84h4.27c2.03,0,4,1.04,4.92,2.84,1.33,2.59,4.38,4.41,7.96,4.41s6.63-1.82,7.96-4.41c.93-1.81,2.89-2.84,4.93-2.84h3.73c2.03,0,4,1.03,4.93,2.84,1.33,2.59,4.39,4.41,7.96,4.41,3.57,0,6.63-1.82,7.96-4.41.92-1.81,2.89-2.84,4.92-2.84h3.93c2.03,0,4,1.04,4.92,2.84,1.33,2.59,4.38,4.41,7.96,4.41,3.56,0,6.63-1.82,7.96-4.41.93-1.81,2.89-2.84,4.93-2.84h4.27c2.03,0,4,1.04,4.92,2.84,1.33,2.59,4.38,4.41,7.96,4.41,3.56,0,6.63-1.82,7.96-4.41.93-1.81,2.89-2.84,4.93-2.84h3.73c2.03,0,4,1.03,4.93,2.84,1.33,2.59,4.39,4.41,7.96,4.41,3.57,0,6.63-1.82,7.96-4.41.92-1.81,2.89-2.84,4.92-2.84h2.83c3.03,0,5.49,2.46,5.49,5.49v117.75s-96.79,74.42-96.79,74.42l-28.36-21.57-26.02,18.97-97.15-74.14Z"
			})] }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("circle", {
				className: "cls-5",
				cx: 169.09,
				cy: 142.81,
				r: 40
			}), /* @__PURE__ */ _jsx("path", {
				className: "cls-3",
				d: "M153.37,140.39l14.24,15.25c.75.8,2.06.67,2.63-.26l18.38-24.59"
			})] })]
		})
	]
});
const ForwardRef = forwardRef(SvgEmailVerified);
export default ForwardRef;
